import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import SliderViewStyle from './SliderViewStyle';
import SliderViewModel from './SliderViewModel';
import { View, Slider, Text, Dimensions } from 'react-native';
export default class SliderView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new SliderViewModel(this), new SliderViewStyle(this));
    }
    /* RENDERING */
    render() {
        this.binding.handleReset();
        return (React.createElement(View, null,
            React.createElement(View, { style: { width: 45, paddingBottom: 5, left: (this.state.sliderValue * ((Dimensions.get('window').width - ((this.props.paddingLeft * 2) + this.props.paddingRight)) / this.props.maximumValue)) } },
                React.createElement(Text, { style: [this.props.textStyle != undefined ? this.props.textStyle : this.style.styleText] }, (Math.floor(this.state.sliderValue)).toString() + this.props.suffixTitle)),
            React.createElement(Slider, { ref: (r) => this.binding.slider = r, onSlidingComplete: (value) => this.binding.handleSliderReleased(value), thumbTintColor: this.props.thumbColorSlider, onValueChange: (value) => this.binding.handleSliderValueChange(value), minimumTrackTintColor: this.props.leftTrackbarColor, minimumValue: this.props.minimumValue, value: this.props.defaultValue, maximumValue: this.props.maximumValue })));
    }
}
